// extracted by mini-css-extract-plugin
module.exports = {"Container":"DownloadCSVTable_Container__37GlD","Link":"DownloadCSVTable_Link__27Xtn","DownloadImage":"DownloadCSVTable_DownloadImage__1KhZL"};